import { PageHeader, Upload } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { isPlatformOrg } from 'domains/orgDomain';
import { EMPTY_BASE_SVC } from 'domains/svcDomain';
import { useOrgId } from 'hooks/useOrg';
import { useTranslation } from 'react-i18next';

export const SVCHeader = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const orgId = useOrgId();
  const isBaseOrg = isPlatformOrg({ id: orgId });
  const formVisible = useAppSelector(
    (state) =>
      state.svc.creatingSvc ||
      state.svc.creatingSvcSpec ||
      state.svc.viewingSvc ||
      state.svc.viewingSvcSpec
  );

  const importLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.importServices
  );

  const exportLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.exportServices
  );

  const importFile = (
    <Upload
      maxCount={1}
      disabled={importLoading}
      showUploadList={false}
      customRequest={async (option) => {
        const formData = new FormData();
        formData.append('file', option.file);
        await dispatch.excelDefinition.importServices(formData);
        await dispatch.svc.getAllSVCs();
        dispatch.svc.setState({
          currentPage: 1,
        });
      }}
    >
      <RevxButton key="import" brandGreen loading={importLoading}>
        {t('common.import')}
      </RevxButton>
    </Upload>
  );

  const exportFile = (
    <RevxButton
      key="export"
      brandGreen
      loading={exportLoading}
      onClick={() => {
        dispatch.excelDefinition.exportServices();
      }}
    >
      {t('common.export')}
    </RevxButton>
  );

  const createButton = (
    <RevxButton
      key="create"
      brandGreen
      disabled={formVisible}
      onClick={() => {
        if (isBaseOrg) {
          dispatch.svc.setState({
            creatingSvc: true,
            curItem: EMPTY_BASE_SVC,
          });
        } else {
          dispatch.svc.updateBaseSelectVisible(true);
        }
      }}
    >
      {isBaseOrg
        ? t('platform.svc.createBaseSvc')
        : t('platform.svc.createSvc')}
    </RevxButton>
  );

  return (
    <PageHeader
      className="platform-page-header"
      ghost={false}
      title={
        isBaseOrg
          ? t('platform.header.baseServices')
          : t('platform.header.services')
      }
      extra={[exportFile, importFile, createButton]}
    />
  );
};
